/* HIDEandSTITCH: tabs for the featured products section and the certificate viewer. */
(function () {
  'use strict';

  if (!customElements.get('hs-tabs')) {
    customElements.define(
      'hs-tabs',
      class HsTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab));
            tab.addEventListener('keydown', (event) => this.onKey(event, tab));
          });
        }

        select(tab, focus) {
          this.tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) tab.focus();
        }

        onKey(event, tab) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const i = this.tabs.indexOf(tab);
          const step = event.key === 'ArrowRight' ? 1 : -1;
          this.select(this.tabs[(i + step + this.tabs.length) % this.tabs.length], true);
        }
      }
    );
  }

  /* Keep the brand written as HIDEandSTITCH inside labels that CSS sets in capitals */
  const BRAND = 'HIDEandSTITCH';

  function protectBrand(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        node.nodeValue.includes(BRAND) && !node.parentElement.closest('.hs-brandname, script, style, textarea, title')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const parts = node.nodeValue.split(BRAND);
      const frag = document.createDocumentFragment();
      parts.forEach((part, i) => {
        if (part) frag.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          const span = document.createElement('span');
          span.className = 'hs-brandname';
          span.textContent = BRAND;
          frag.appendChild(span);
        }
      });
      node.replaceWith(frag);
    });
  }

  function watchBrand() {
    protectBrand(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) protectBrand(n);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBrand);
  } else {
    watchBrand();
  }

  let dialog = null;

  function getDialog() {
    if (dialog) return dialog;
    const host = document.createElement('div');
    host.className = 'hs-scope hs-dialog-host';
    host.innerHTML =
      '<dialog class="hs-dialog hs-dialog--wide" aria-labelledby="HsLightboxTitle">' +
      '<div class="hs-dialog__inner">' +
      '<div class="hs-dialog__head"><h2 class="hs-h4" id="HsLightboxTitle"></h2>' +
      '<button type="button" class="hs-icon-btn" data-hs-close aria-label="Close">' +
      '<svg class="hs-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button></div>' +
      '<img class="hs-lightbox-img" alt="">' +
      '</div></dialog>';
    document.body.appendChild(host);
    dialog = host.querySelector('dialog');
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-hs-close]')) dialog.close();
    });
    return dialog;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hs-lightbox]');
    if (!trigger) return;
    const d = getDialog();
    const title = trigger.dataset.title || '';
    d.querySelector('#HsLightboxTitle').textContent = title;
    const img = d.querySelector('.hs-lightbox-img');
    img.src = trigger.dataset.hsLightbox;
    img.alt = title ? 'Scan of the ' + title + ' certificate' : '';
    d.showModal();
  });
})();
